<template>
  <div id="edit_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Link</h5>

          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Marketplace<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <select v-model="formData.mp_id" class="form-control">
                            <option :value="''">All</option>

                            <template v-if="dataListMarketplace.length">
                              <option
                                :value="marketplace"
                                v-for="(marketplace,
                                idx) in dataListMarketplace"
                                :key="idx"
                                >{{ marketplace | capitalising }}</option
                              >
                            </template>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Status<span class="text text-danger">*</span></label
                        >

                        <div class="col-md-8">
                          <select
                            v-model="formData.status_value"
                            class="form-control"
                          >
                            <option :value="''">All</option>

                            <template v-if="dataListMonitoringStatus.length">
                              <template
                                v-for="(row, idx) in dataListMonitoringStatus"
                              >
                                <option
                                  :value="row.id"
                                  v-if="
                                    row.id == 'raw' ||
                                      row.id == 'processing' ||
                                      row.id == 'closed'
                                  "
                                  :key="idx"
                                  >{{ row.label }}</option
                                >
                              </template>
                            </template>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Brand<span class="text text-danger">*</span></label
                        >

                        <div class="col-md-8">
                          <multiselect
                            v-model="selectedContact"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :placeholder="'Type to search Brand...'"
                            :multiple="true"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="contactOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFind"
                            :show-labels="false"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>

                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContact.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>

                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Product<span class="text text-danger">*</span></label
                        >

                        <div class="col-md-8">
                          <multiselect
                            v-if="selectedContact.length"
                            v-model="selectedProduct"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :placeholder="'Type to search Product...'"
                            :multiple="true"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="productOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFindProduct"
                            :show-labels="false"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>

                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>

                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedProduct.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>

                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Username Toko<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <input
                            v-model="formData.store_name"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Link Toko<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <input
                            v-model="formData.store_link"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Nama Produk<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <input
                            v-model="formData.product_name"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Link Produk<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <input
                            v-model="formData.product_url"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Harga Minimal<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <input
                            v-model="formData.product_price_start"
                            type="number"
                            min="0"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Harga Maksimal<span class="text text-danger"
                            >*</span
                          ></label
                        >

                        <div class="col-md-8">
                          <input
                            v-model="formData.product_price_end"
                            type="number"
                            min="0"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <label class="col"
                          >Gambar Produk<span class="text text-danger"
                            >*</span
                          ></label
                        >
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="mb-3" v-if="loading">
                            <skeleton />
                          </div>

                          <!-- <div
                            class="relative image-preview mb-3"
                            v-if="formData.product_image1"
                          >
                            <img
                              title="Lihat Gambar Produk"
                              @click="openImage(formData.product_image1)"
                              class="preview"
                              :src="formData.product_image1"
                            />

                            <button
                              @click.prevent="removeProductImage()"
                              title="Hapus Gambar Produk"
                              type="button"
                              class="remove-image"
                            >
                              &times;
                            </button>
                          </div> -->
                          <div class="">
                            <!-- {{ formData.scraping_file_screenshot }} -->
                            <imageUpload ref="product_image1" :limit="1" v-model="formData.product_image1" @input="uploadImage1" />
                          </div>
                          <!-- <div class="box-image">
                            <label class="btn btn-md btn-success">
                              <input
                                type="file"
                                accept="image/jpg, image/jpeg, image/png"
                                ref="product_image1"
                                name="product_image1"
                                @change="onFileSelected()"
                              />
                              Pilih File
                            </label>
                          </div> -->
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="row">
                        <label class="col"
                          >Screenshot<span class="text text-danger"
                            >*</span
                          ></label
                        >
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="mb-3" v-if="loading2">
                            <skeleton />
                          </div>

                          <!-- <div
                            class="relative image-preview mb-3"
                            v-if="formData.scraping_file_screenshot"
                          >
                            <img
                              title="Lihat Screenshot"
                              @click="
                                openImage(formData.scraping_file_screenshot)
                              "
                              class="preview"
                              :src="formData.scraping_file_screenshot"
                            />

                            <button
                              @click.prevent="removeScreenshot()"
                              title="Hapus Screenshot"
                              type="button"
                              class="remove-image"
                            >
                              &times;
                            </button>
                          </div> -->
                          <div class="">
                            <!-- {{ formData.scraping_file_screenshot }} -->
                            <imageUpload ref="scraping_file_screenshot" :limit="1" v-model="formData.scraping_file_screenshot" @input="uploadImage" />
                          </div>

                          <!-- <div class="box-image">
                            <label class="btn btn-md btn-success">
                              <input
                                type="file"
                                accept="image/jpg, image/jpeg, image/png"
                                ref="scraping_file_screenshot"
                                name="scraping_file_screenshot"
                                @change="onFileSelected2()"
                              />
                              Pilih File
                            </label>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <small style="font-weight: bold">
                        Upload File pastikan jpg, jpeg, png dan size tidak lebih
                        dari 1MB</small
                      >
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div style="text-align: right;">
                        <button
                          @click.prevent="clearForm"
                          type="button"
                          class="btn btn-md btn-light"
                        >
                          <i class="fa fa-trash"></i> Reset
                        </button>

                        <button
                          @click.prevent="addForm"
                          class="btn btn-md btn-warning"
                          type="button"
                          :style="
                            'margin-left:10px; color: #fff; background-color: #ff9b44; border-color: #ff9b44;'
                          "
                        >
                          <i class="la la-plus"></i> Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import VueSimpleAlert from "vue-simple-alert";
import ImageUpload from "./imageUpload/index.vue";

export default {
  components: {
    Skeleton,
    Multiselect,
    ImageUpload
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      showUpload:'',
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        id: "",
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      dataListMonitoringStatus: [],
      dataListMarketplace: [],
      formData: {
        id: "",
        mp_id: "",
        brand_id: "",
        product_id: "",
        store_name: "",
        store_link: "",
        product_name: "",
        product_url: "",
        product_price_start: "",
        product_price_end: "",
        product_image1: [],
        scraping_file_screenshot: [],
        status_value: ""
      },
      isLoading: false,
      loading: false,
      loading2: false,
      productImage1Temp: "",
      screenshotTemp: "",
      addLoading: false
    };
  },
  watch: {
    selectedProduct: {
      handler: function(val, oldVal) {
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedProduct = val;
        }
        if (val.length == 1) {
          this.formData.product_id = val[0].id;
        } else {
          this.formData.product_id = "";
        }
      },
      deep: true
    },

    selectedContact: {
      handler: function(val, oldVal) {
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
        }
        if (val.length == 1) {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formData.brand_id = val[0].id;
          this.asyncFindProduct();
        } else {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formData.brand_id = "";
        }
      },
      deep: true
    },

    isShowFormEdit: {
      handler: function(val, oldVal) {
        if (val == true) {
          var that = this;
          setTimeout(async function() {
            // console.log("that.actFormEditSt", that.actFormEditSt);
            await that.clearForm();
            await that.getMonitoringListStatus();
            await that.getMarketplaceList();
            await that.getDetailLink(that.isShowFormEditId);
            await that.asyncFind();
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    isShowFormEdit() {
      return this.$store.state.monitoring.isShowFormEdit;
    },
    isShowFormEditId() {
      return this.$store.state.monitoring.isShowFormEditId;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    async getDetailLink(id) {
      let serverParams = {
        columnFilters: {
          id
        },
        page: 0,
        perPage: 20
      };

      await this.$store
        .dispatch("monitoring/listLink", serverParams)
        .then(response => {
          const { data } = response.data;

          // if (data.data[0].input_via != "manual") {
          //   this.$fire({
          //     title: "Error",
          //     text: "Edit hanya bisa dilakukan untuk input link manual.",
          //     type: "error",
          //     timer: 2000
          //   }).then(_ => {
          //     this.clearForm();
          //     this.searchData();
          //     var elem = this.$refs.dismisModal;
          //     elem.click();
          //   });
          //   return;
          // }

          this.formData.id = data[0].id;
          this.formData.mp_id = data[0].mp_id;
          this.formData.brand_id = data[0].brand_id;
          this.formData.product_id = data[0].product_id;
          this.formData.store_name = data[0].store_name;
          this.formData.store_link = data[0].store_link;
          this.formData.product_name = data[0].product_name;
          this.formData.product_url = data[0].product_url;
          this.formData.product_price_start = data[0].product_price_start;
          this.formData.product_price_end = data[0].product_price_end;
          this.formData.product_image1 = data[0].product_image ? [data[0].product_image] : [];
          this.formData.scraping_file_screenshot =
          data[0].scraping_file_screenshot ? [data[0].scraping_file_screenshot] : [];
          this.formData.status_value = data[0].status_value;
        });
    },

    onFileSelected() {
      this.productImage1Temp = this.$refs.product_image1.files[0];
      if (
        this.productImage1Temp.type == "image/jpg" ||
        this.productImage1Temp.type == "image/jpeg" ||
        this.productImage1Temp.type == "image/png"
      ) {
        const formData = new FormData();
        formData.append("file", this.productImage1Temp);
        formData.append("folder_name", "static");
        this.loading = true;
        this.$store
          .dispatch("monitoring/upload_attachment", formData)
          .then(res => {
            const { data } = res;
            this.formData.product_image1 = data.url;
            this.$refs.product_image1.value = null;
            this.loading = false;
          })
          .catch(err => {
            this.$refs.product_image1.value = null;
            this.loading = false;
          });
      } else {
        this.$refs.product_image1.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Format file tidak diperbolehkan.",
          type: "error",
          timer: 3000
        });
      }
    },
    uploadImage1(val) {
      this.productImage1Temp = val[0]
      if (
        this.productImage1Temp.type == "image/jpg" ||
        this.productImage1Temp.type == "image/jpeg" ||
        this.productImage1Temp.type == "image/png"
      ) {
        const formData = new FormData();
        formData.append("file", this.productImage1Temp);
        formData.append("folder_name", "static");
        // this.loading = true;
        this.$store
          .dispatch("monitoring/upload_attachment", formData)
          .then(res => {
            const { data } = res;
            this.formData.product_image1 = [data.url];
            this.$refs.product_image1.value = null;
            // this.loading = false;
          })
          .catch(err => {
            this.$refs.product_image1.value = null;
            // this.loading = false;
          });
      } else {
        this.$refs.product_image1.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Format file tidak diperbolehkan.",
          type: "error",
          timer: 3000
        });
      }
    },
    uploadImage(val){
      this.screenshotTemp = val[0]
      if (
        this.screenshotTemp.type == "image/jpg" ||
        this.screenshotTemp.type == "image/jpeg" ||
        this.screenshotTemp.type == "image/png"
      ) {
        const formData = new FormData();
        formData.append("file", this.screenshotTemp);
        formData.append("folder_name", "static");
        // this.loading2 = true;
        this.$store
          .dispatch("monitoring/upload_attachment", formData)
          .then(res => {
            const { data } = res;
            this.formData.scraping_file_screenshot = [data.url];
            this.$refs.scraping_file_screenshot.value = null;
            // this.loading2 = false;
          })
          .catch(err => {
            this.$refs.scraping_file_screenshot.value = null;
            // this.loading2 = false;
          });
      } else {
        this.$refs.scraping_file_screenshot.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Format file tidak diperbolehkan.",
          type: "error",
          timer: 3000
        });
      }
    },
    onFileSelected2() {
      this.screenshotTemp = this.$refs.scraping_file_screenshot.files[0];
      if (
        this.screenshotTemp.type == "image/jpg" ||
        this.screenshotTemp.type == "image/jpeg" ||
        this.screenshotTemp.type == "image/png"
      ) {
        const formData = new FormData();
        formData.append("file", this.screenshotTemp);
        formData.append("folder_name", "static");
        this.loading2 = true;
        this.$store
          .dispatch("monitoring/upload_attachment", formData)
          .then(res => {
            const { data } = res;
            this.formData.scraping_file_screenshot = data.url;
            this.$refs.scraping_file_screenshot.value = null;
            this.loading2 = false;
          })
          .catch(err => {
            this.$refs.scraping_file_screenshot.value = null;
            this.loading2 = false;
          });
      } else {
        this.$refs.scraping_file_screenshot.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Format file tidak diperbolehkan.",
          type: "error",
          timer: 3000
        });
      }
    },

    removeProductImage() {
      this.formData.product_image1 = "";
    },

    removeScreenshot() {
      this.formData.scraping_file_screenshot = "";
    },

    openImage(url) {
      window.open(url, "_blank");
    },

    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      this.productListParam.brand_id = this.selectedContact[0].id;
      var formProductId = this.formData.product_id;
      this.productListParam.id = formProductId;
      this.$store
        .dispatch("brandProduct/list", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
          if (formProductId) {
            this.productOptions.forEach(item => {
              if (item.id == formProductId) {
                this.selectedProduct.push(item);
              }
            });
          }
        })
        .catch(error => {
          this.isLoading = false;
        });
    },

    limitText(count) {
      return `and ${count} other`;
    },

    customLabel({ name }) {
      return `${name}`;
    },

    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = this.formData.brand_id;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(async response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (this.formData.brand_id) {
            this.contactOptions.forEach(item => {
              if (item.id == this.formData.brand_id) {
                this.selectedContact.push(item);
              }
            });
            this.asyncFindProduct();
          }
        })
        .catch(error => {
          this.isLoading = false;
        });
    },

    clearAll() {
      this.selectedContact = [];
    },

    clearForm() {
      this.formData.mp_id = "";
      this.formData.brand_id = "";
      this.formData.product_id = "";
      this.formData.store_name = "";
      this.formData.store_link = "";
      this.formData.product_name = "";
      this.formData.product_url = "";
      this.formData.product_price_start = "";
      this.formData.product_price_end = "";
      this.formData.product_image1 = [];
      // this.$refs.product_image1.value = null;
      this.formData.scraping_file_screenshot = [];
      // this.$refs.scraping_file_screenshot.value = null;
      this.formData.status_value = "";
      
      this.$refs.product_image1.closeModal()
      this.$refs.scraping_file_screenshot.closeModal()
      this.clearAll();
    },

    addForm() {
      this.addLoading = true;
      let formData  = {
        ...this.formData,
        product_image1: this.formData.product_image1.length > 0 ? this.formData.product_image1[0] : '',
        scraping_file_screenshot: this.formData.scraping_file_screenshot.length > 0 ? this.formData.scraping_file_screenshot[0] : '',
      }
      this.$store
        .dispatch("monitoring/validationManualUpdate", formData)
        .then(_ => {
          this.$fire({
            title: "Lanjutkan update link?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: `Yes`,
            denyButtonText: `Cancel`
          }).then(async r => {
            if (r.value == true) {
              this.$store
                .dispatch("monitoring/storedManualUpdate", formData)
                .then(_ => {
                  VueSimpleAlert.fire({
                    title: "Success",
                    text: "Link berhasil diupdate.",
                    type: "success",
                    timer: 3000
                  });
                  this.addLoading = false;
                  this.clearForm();
                  this.searchData();
                  var elem = this.$refs.dismisModal;
                  elem.click();
                })
                .catch(error => {
                  this.addLoading = false;
                  console.error(error);
                });
            } else {
              this.addLoading = false;
            }
          });
        })
        .catch(error => {
          this.addLoading = false;
          console.error(error);
        });
    },

    getMarketplaceList() {
      this.$store.dispatch("monitoring/getMarketplaceList").then(respons => {
        this.dataListMarketplace = respons.data;
      });
    },

    getMonitoringListStatus() {
      this.$store
        .dispatch("monitoring/getMonitoringListStatus")
        .then(respons => {
          this.dataListMonitoringStatus = respons.data;
        });
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "from-edit"
};
</script>

<style scoped>
.remove-image {
  position: absolute;
  top: 0;
  right: 15px;
  display: block;
  padding: 4px 10px;
  border-radius: 0 4px 0 4px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  border: none;
}

.image-preview img {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.image-preview img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  display: inline-block;
  padding: 0 15px;
  border-radius: 4px;
  cursor: pointer;
}

.custom-file-upload:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/links/edit.vue